export function sanitizeReturnPath(
  value: string | null | undefined,
  fallback = "/questions"
): string {
  if (
    !value ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    /[\\\u0000-\u001f]/.test(value)
  ) {
    return fallback;
  }
  return value;
}

export function currentReturnPath(
  location: Pick<Location, "pathname" | "search" | "hash"> = window.location
): string {
  return sanitizeReturnPath(
    `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`,
    "/"
  );
}

export function loginUrlForReturnPath(
  returnPath: string,
  options: { expired?: boolean; authenticationRequired?: boolean } = {}
): string {
  const params = new URLSearchParams();
  if (options.expired) params.set("expired", "true");
  if (options.authenticationRequired) {
    params.set("reason", "authentication-required");
  }
  params.set("returnUrl", sanitizeReturnPath(returnPath, "/"));
  return `/login?${params.toString()}`;
}
